// import DateTime from 'luxon/src/datetime';
import { DateTime } from "luxon";

export default {
    // 2022-10-26 16:01:15
    // yyyy-LL-dd hh:mm:ss
    formatDateTime(date) {
        if (!date) return;
        const fromFormat = DateTime.fromFormat(date, "yyyy-LL-dd hh:mm:ss");
        return fromFormat.toLocaleString(DateTime.DATETIME_MED);
    },
    // 2022-10-26T16:01:15.0000
    // yyyy-LL-dd hh:mm:ss
    formatDateTimeV2(date) {
        if (!date) return;
        const formattedData = date.replace("T", " ").split(".")[0];
        const fromFormat = DateTime.fromFormat(
            formattedData,
            "yyyy-LL-dd hh:mm:ss"
        );
        return fromFormat.toLocaleString(DateTime.DATETIME_MED);
    },
    // 2022-10-26
    // yyyy-LL-dd
    formatDate(date) {
        if (!date) return;
        const fromFormat = DateTime.fromFormat(date, "yyyy-LL-dd");
        return fromFormat.toLocaleString(DateTime.DATE_FULL);
    },
    // Tue Nov 01 2022 00:00:00 GMT+0800 (Philippine Standard Time)
    // yyyy-LL-dd or yyyy-LL-dd hh:mm:ss
    formatFromPST(date, time = false) {
        if (!date) return;
        if (time)
            return DateTime.fromJSDate(date).toFormat("yyyy-LL-dd hh:mm:ss");
        else return DateTime.fromJSDate(date).toFormat("yyyy-LL-dd");
    },
    // yyyy-LL-dd
    // Tue Nov 01 2022 00:00:00 GMT+0800 (Philippine Standard Time)
    formatToPST(date) {
        if (!date) return;
        const fromFormat = DateTime.fromFormat(date, "yyyy-LL-dd");
        return fromFormat.toJSDate();
    },
    // Oct 14, 1983
    // yyyy-LL-dd
    formatFromDateMed(date) {
        if (!date) return;
        const fromFormat = DateTime.fromFormat(date, "DD");
        return fromFormat.toFormat("yyyy-LL-dd");
    },
    // Date now
    // Jan 19, 2023, 5_23 PM
    exportExcelDate() {
        return DateTime.fromISO(DateTime.utc().toISO()).toFormat("ff");
    },
};
